import React from "react";
import ZoneList from "./component/ZoneList";

const Zone = () => {
  return (
    <div>
      <ZoneList />
    </div>
  );
};

export default Zone;
